"use client";

import { useEffect } from "react";
import "~/styles/globals.css";
import { useRecoilState } from "recoil";
import { configsAtom } from "~/state/atoms";
import { api } from "~/trpc/react";

export const useConfig = () => {
  const [configs, setConfigs] = useRecoilState(configsAtom);

  const apiGetConfigs = api.common.getConfigs.useQuery();

  useEffect(() => {
    if (apiGetConfigs.data) {
      setConfigs(apiGetConfigs.data);
      localStorage.setItem("configs", JSON.stringify(apiGetConfigs.data));
    }
  }, [apiGetConfigs]);

  const getConfigValue = (key: string) => {
    return configs.find((item) => item.key === key)?.value;
  };

  return { getConfigValue };
};
